const BaseColor = {
  black: "#000000",
  white: "#ffffff",
  primary: "#4569FF",
  danger: "#EE4C50",
  overlay: "#18191aeb",
};
const fontSize = {
  xs: "14px",
  sm: "16px",
  re: "20px",
  md: "24px",
  lg: "28px",
  xl: "32px",
  xxl: "40px",
};
const shadow = {
  sm: "0px 0px 2px rgba(0, 0, 0, 0.06)",
  md: "0px 2px 7px rgba(0, 0, 0, 0.07)",
};
const mixins = {
  gap: (value, direction = "row") => `
		& > *:not(:last-child){
			margin-${direction === "column" ? "bottom" : "right"}: ${value};
		}
	`,
  fade: (type) => `
		transition: visibility 1s, opacity 1s;
		visibility: ${type === "hide" ? "hidden" : "visible"};
		opacity: ${type === "hide" ? 0 : 1};
		pointer-events: ${type === "hide" ? "none" : "all"};
	  `,
  linesLimits: (lines, lineHeight = "1.5") => `
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: ${lines};
		-webkit-box-orient: vertical;
		line-height: ${lineHeight};
	`,
  hideScroller: () => `
		-ms-overflow-style: none;  /* IE and Edge */
		scrollbar-width: none;  /* Firefox */
		&::-webkit-scrollbar {
			display: none;
		}
	`,
  textGradient: (colorGradient) => `
		background: ${colorGradient};
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	`,
};

export const themeDark = {
  mode: "dark",
  ...mixins,
  fontSize: {
    ...fontSize,
  },
  shadow: {
    ...shadow,
  },
  color: {
    ...BaseColor,
    primaryText: "#F2F5FF",
    darkerText: "#F2F5FF",
    lighterText: "#ABABAB",
    background: "#18191A",
    secondaryBg: "#202020",
    border: "#262626",
    secondaryIcon: "#65676B",
    linkText: "#797F8A",
  },
};

export const themeLight = {
  mode: "light",
  ...mixins,
  fontSize: {
    ...fontSize,
  },
  shadow: {
    ...shadow,
  },
  color: {
    ...BaseColor,
    primaryText: "#4569FF",
    darkerText: "#1B1B1B",
    lighterText: "#5F5F5F",
    background: "#ffffff",
    secondaryBg: "#F2F5FF",
    border: "#F0F4F8",
    secondaryIcon: "#9EACBF",
    linkText: "#516272",
  },
};
